import axios from "axios";
import { setIsLoading } from "../../../redux/loader/action";
import store from "../../../redux/store";

const getTeamApiCall = async (promocode, isLoading = true) => {
  try {
    isLoading && store.dispatch(setIsLoading(true));
    let url = `${process.env.REACT_APP_GET_MY_TEAM}${promocode}`;
    const res = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY
      }
    });
    isLoading && store.dispatch(setIsLoading(false));
    return res.data.data;
  } catch (error) {
    return [];
  }
};

export default getTeamApiCall;
